import { IsNotEmpty, IsString } from 'class-validator';

export class CreateClientDto
{
    @IsString()
    @IsNotEmpty()
    clientId!: string;
}